(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amory-mini-gpt"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('amory-mini-gpt')) {
  customElements.define('amory-mini-gpt', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.signal = this.controller.signal;
      this.variants = JSON.parse(this.querySelector('[data-am5-variants]').textContent);
      this.mainRoot = document.querySelector(this.dataset.mainAnchor);
      this.mainForm = this.mainRoot?.querySelector('form[id^="product-form-"]');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.motionEnabled = this.dataset.motion === 'true';
      this.observers = [];
      this.steps = 6240;
      this.callActive = false;
      const on = (el, type, fn) => el?.addEventListener(type, fn, { signal: this.signal });
      const text = (key) => this.querySelector('[data-am5-' + key + ']')?.content?.textContent.trim() || '';
      this.templateText = text;
      on(this, 'click', (event) => {
        const motionButton = event.target.closest('[data-am5-motion]');
        if (motionButton) { this.motionEnabled = !this.motionEnabled; this.updateMotion(); return; }
        const sizeButton = event.target.closest('[data-am5-size]');
        if (sizeButton) {
          const regular = sizeButton.dataset.am5Size === 'regular';
          this.querySelectorAll('[data-am5-size]').forEach(button => button.setAttribute('aria-pressed', String(button === sizeButton)));
          this.querySelector('[data-am5-size-stage]').classList.toggle('is-regular', regular);
          this.querySelector('[data-am5-mm]').textContent = regular ? '43 mm' : '39,5 mm';
          this.querySelector('[data-am5-size-label]').textContent = text(regular ? 'regular-label' : 'mini-label');
          return;
        }
        const demoButton = event.target.closest('[data-am5-demo]');
        if (demoButton) {
          const choice = demoButton.dataset.am5Demo;
          this.querySelectorAll('[data-am5-demo]').forEach(button => button.setAttribute('aria-pressed', String(button === demoButton)));
          this.querySelectorAll('[data-am5-screen]').forEach(panel => { panel.hidden = panel.dataset.am5Screen !== choice; });
          this.querySelectorAll('[data-am5-panel]').forEach(panel => { panel.hidden = panel.dataset.am5Panel !== choice; });
          const notification = this.querySelector('[data-am5-screen="' + choice + '"]');
          if (this.dataset.running === 'true') notification?.animate?.([{opacity:0,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:350,easing:'ease-out'});
          return;
        }
        const call = event.target.closest('[data-am5-call]');
        if (call) {
          this.callActive = !this.callActive;
          call.classList.toggle('is-active', this.callActive);
          call.setAttribute('aria-label', text(this.callActive ? 'call-end' : 'call-action'));
          this.querySelector('[data-am5-call-label]').textContent = text(this.callActive ? 'call-active' : 'call-incoming');
          return;
        }
        if (event.target.closest('[data-am5-walk]')) {
          this.steps = this.steps >= 8000 ? 6240 : Math.min(8000, this.steps + 800);
          this.querySelector('[data-am5-steps]').textContent = new Intl.NumberFormat('de-DE').format(this.steps);
          this.querySelector('.am5-ring-progress').style.strokeDashoffset = String(100 - this.steps / 80);
          this.querySelector('[data-am5-walk-status]').textContent = this.steps === 8000 ? text('move-done') : '';
          return;
        }
        const faceButton = event.target.closest('[data-am5-face]');
        if (faceButton) {
          const choice = faceButton.dataset.am5Face;
          this.querySelectorAll('[data-am5-face]').forEach(button => button.setAttribute('aria-pressed', String(button === faceButton)));
          this.querySelectorAll('[data-am5-face-image]').forEach(panel => { panel.hidden = panel.dataset.am5FaceImage !== choice; });
          const activeImage = this.querySelector('[data-am5-face-image="' + choice + '"]');
          if (this.dataset.running === 'true' && activeImage?.animate) activeImage.animate([{opacity:0},{opacity:1}],{duration:400,easing:'ease-out'});
          return;
        }
        const variantButton = event.target.closest('[data-am5-variant]');
        if (variantButton) {
          const variant = this.variants.find(item => String(item.id) === variantButton.dataset.am5Variant);
          if (!variant || !variant.available) return;
          const input = Array.from(this.mainRoot?.querySelectorAll('input[type="radio"][name="option1"]') || []).find(el => el.value === variant.option);
          const select = this.mainRoot?.querySelector('select[name="option1"]');
          if (input) {
            input.click();
            this.setVariant(variant.id);
          } else if (select) {
            select.value = variant.option;
            select.dispatchEvent(new Event('change', {bubbles:true}));
            this.setVariant(variant.id);
          } else {
            this.setVariant(variant.id);
          }
          return;
        }
      });
      on(this.mainRoot, 'variant:changed', event => {
        if (event.detail?.variant?.id) this.setVariant(event.detail.variant.id);
        else this.syncFromForm();
      });
      on(this.mainRoot, 'change', () => {
        clearTimeout(this.syncTimer);
        this.syncTimer = setTimeout(() => this.syncFromForm(), 150);
      });
      on(document, 'visibilitychange', () => this.updateMotion());
      on(this.reducedMotion, 'change', () => this.updateMotion());
      this.classList.add('is-ready');
      this.updateMotion();
      this.syncFromForm();
      if ('IntersectionObserver' in window) {
        const revealObserver = new IntersectionObserver(entries => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              entry.target.classList.remove('am5-pending');
              revealObserver.unobserve(entry.target);
            }
          }
        }, {rootMargin:'0px 0px -30px 0px',threshold:0.05});
        this.querySelectorAll('.am5-reveal').forEach(element => {
          if (element.getBoundingClientRect().top > window.innerHeight && this.dataset.running === 'true') element.classList.add('am5-pending');
          revealObserver.observe(element);
        });
        const sceneObserver = new IntersectionObserver(entries => {
          for (const entry of entries) entry.target.classList.toggle('am5-inview', entry.isIntersecting);
        }, {rootMargin:'100px 0px',threshold:0});
        this.querySelectorAll('.am5-observe').forEach(element => sceneObserver.observe(element));
        this.observers.push(revealObserver, sceneObserver);
      } else {
        this.querySelectorAll('.am5-observe').forEach(element => element.classList.add('am5-inview'));
      }
    }
    updateMotion() {
      const running = this.motionEnabled && !this.reducedMotion.matches && !document.hidden;
      this.dataset.running = String(running);
      this.classList.toggle('am5-no-motion', !this.motionEnabled || this.reducedMotion.matches);
      const button = this.querySelector('[data-am5-motion]');
      if (button) {
        button.setAttribute('aria-pressed', String(!running));
        button.setAttribute('aria-label', running ? this.dataset.pauseLabel : this.dataset.resumeLabel);
        button.querySelector('span').textContent = running ? 'Ⅱ' : '▷';
        button.disabled = this.reducedMotion.matches;
      }
      if (!running) this.querySelectorAll('.am5-pending').forEach(element => element.classList.remove('am5-pending'));
    }
    setVariant(id) {
      const variant = this.variants.find(item => String(item.id) === String(id));
      if (!variant) return;
      this.querySelectorAll('[data-am5-variant]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.am5Variant === String(id))));
      this.querySelectorAll('[data-am5-variant-image]').forEach(image => { image.hidden = image.dataset.am5VariantImage !== String(id); });
      this.querySelector('[data-am5-color-label]').textContent = variant.title;
      if (this.activeVariant !== String(id) && this.dataset.running === 'true') {
        const image = this.querySelector('[data-am5-variant-image="' + id + '"]');
        image?.animate?.([{opacity:.1,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:450,easing:'ease-out'});
      }
      this.activeVariant = String(id);
    }
    syncFromForm() {
      const input = this.mainForm?.querySelector('[name="id"]');
      if (input?.value) this.setVariant(input.value);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observers?.forEach(observer => observer.disconnect());
      clearTimeout(this.syncTimer);
      this.controller = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ap-widget"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var trig = document.getElementById('ap-trigger-card');
    var close = document.getElementById('ap-close');
    var sheet = document.getElementById('ap-sheet');
    var ov = document.getElementById('ap-overlay');
    var header = document.getElementById('ap-header-swipe');
    var scrollArea = document.getElementById('ap-scroll-area');
    var hashWrapper = document.getElementById('ap-hash-trigger');
    var path = document.querySelector('.ap-scribble-path');

    var startY = 0, isDragging = false, currentStage = 0, STAGE_1 = 0, updateInterval = null;

    /* Scribble animation (heading trigger only) */
    if (path && hashWrapper) {
      var length = path.getTotalLength();
      path.style.strokeDasharray = length;
      path.style.strokeDashoffset = length;
      path.style.opacity = '1';
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (e.isIntersecting) {
            path.style.transition = 'stroke-dashoffset 1.2s ease-in-out';
            path.style.strokeDashoffset = '0';
            observer.unobserve(e.target);
          }
        });
      }, { threshold: 0.5 });
      observer.observe(hashWrapper);
    }

    function setSheetY(y, animate) {
      if (animate === undefined) animate = true;
      sheet.style.transition = animate ? 'transform 0.4s cubic-bezier(0.2, 0.8, 0.2, 1)' : 'none';
      if (window.innerWidth >= 768) {
        sheet.style.transform = 'translate3d(0, ' + y + 'px, 0)';
      } else {
        sheet.style.transform = 'translate3d(-50%, ' + y + 'px, 0)';
      }
      if (y <= 10) { sheet.classList.add('is-stage-2'); } else { sheet.classList.remove('is-stage-2'); }
    }

    function toggleSheet(open) {
      if (open) {
        /* Lazy init: compute STAGE_1 on first open. 0.15 on all viewports — sheet opens near the top for full content visibility. */
        STAGE_1 = window.innerHeight * 0.15;
        document.body.classList.add('ap-lock');
        sheet.style.display = 'block';
        ov.style.display = 'block';
        setTimeout(function() {
          ov.classList.add('active');
          sheet.classList.add('active-stage');
          setSheetY(STAGE_1);
          currentStage = 1;
        }, 20);
        updateAppleTime();
        if (!updateInterval) { updateInterval = setInterval(updateAppleTime, 60000); }
      } else {
        if (updateInterval) { clearInterval(updateInterval); updateInterval = null; }
        document.body.classList.remove('ap-lock');
        ov.classList.remove('active');
        sheet.classList.remove('active-stage');
        setSheetY(window.innerHeight * 1.5);
        currentStage = 0;
        setTimeout(function() {
          if (currentStage === 0) { sheet.style.display = 'none'; ov.style.display = 'none'; }
        }, 400);
      }
    }

    ov.addEventListener('touchmove', function(e) { e.preventDefault(); }, {passive: false});

    header.addEventListener('touchstart', function(e) {
      startY = e.touches[0].clientY; isDragging = true; sheet.style.transition = 'none';
    }, {passive: false});
    header.addEventListener('touchmove', function(e) {
      if (!isDragging) return;
      var dY = e.touches[0].clientY - startY;
      var newY = (currentStage === 1 ? STAGE_1 : 0) + dY;
      if (newY < 0) newY *= 0.2;
      setSheetY(newY, false);
      if (Math.abs(dY) > 5) e.preventDefault();
    }, {passive: false});
    header.addEventListener('touchend', function(e) {
      if (!isDragging) return;
      isDragging = false;
      var dY = e.changedTouches[0].clientY - startY;
      if (currentStage === 1) {
        if (dY < -60) { setSheetY(0); currentStage = 2; }
        else if (dY > 100) { toggleSheet(false); }
        else { setSheetY(STAGE_1); }
      } else {
        if (dY > 100) { setSheetY(STAGE_1); currentStage = 1; }
        else { setSheetY(0); }
      }
    });

    var scrollStartY = 0;
    scrollArea.addEventListener('touchstart', function(e) { scrollStartY = e.touches[0].clientY; }, {passive: true});
    scrollArea.addEventListener('touchmove', function(e) {
      var dY = e.touches[0].clientY - scrollStartY;
      if (scrollArea.scrollTop <= 0 && dY > 150 && currentStage === 2) { setSheetY(STAGE_1); currentStage = 1; }
    }, {passive: true});

    trig.onclick = function() { toggleSheet(true); };
    close.onclick = function() { toggleSheet(false); };
    ov.onclick = function() { toggleSheet(false); };

    function updateAppleTime() {
      var now = new Date();
      var timeStr = new Intl.DateTimeFormat('de-DE', { timeZone: 'Europe/Berlin', hour: 'numeric', minute: 'numeric' }).format(now);
      var parts = timeStr.split(':');
      var h = parseInt(parts[0], 10), m = parseInt(parts[1], 10);
      var totalM = (h * 60) + m, day = now.getDay();
      var daysArr = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
      var p = document.getElementById('ap-stat-phone');
      var t = document.getElementById('ap-stat-time');
      var cardText = document.getElementById('ap-card-status-text');
      var cardDot = document.getElementById('ap-card-dot');

      var isWeekday = (day >= 1 && day <= 5);
      var isPhoneOpen = isWeekday && (totalM >= 540 && totalM < 960);
      var isPhoneOpeningSoon = isWeekday && (totalM >= 480 && totalM < 540);
      var isPhoneClosingSoon = isWeekday && (totalM >= 900 && totalM < 960);
      var isPhoneMorning = isWeekday && totalM < 480;
      var isStoreOpen = isWeekday && (totalM >= 480 && totalM < 960);
      var isWeekend = day === 6 || day === 0 || (day === 5 && totalM >= 960);

      var nD = daysArr[day];
      if (isWeekend) { nD = 'Mo.'; } else if (totalM >= 960) { nD = daysArr[day + 1]; }

      var sliderPhoneClosed = 'Erreichbar ab ' + nD + ' 09:00 Uhr';
      var sliderTimeClosed = 'Geschlossen (ab ' + nD + ' 08:00 Uhr ge\u00f6ffnet)';

      if (isPhoneOpen) {
        if (isPhoneClosingSoon) {
          cardText.innerText = 'Bald im Feierabend'; cardDot.className = 'ap-status-dot warning';
          p.className = 'ap-val ap-warning-text';
        } else {
          cardText.innerText = 'Jetzt erreichbar'; cardDot.className = 'ap-status-dot';
          p.className = 'ap-val ap-green';
        }
        p.innerText = 'Jetzt erreichbar';
      } else {
        if (isPhoneOpeningSoon) {
          cardText.innerText = 'Bald erreichbar'; cardDot.className = 'ap-status-dot warning';
          p.className = 'ap-val ap-warning-text';
        } else {
          if (isWeekend) { cardText.innerText = 'Ab Mo. 9:00 Erreichbar'; cardDot.className = 'ap-status-dot pulse-red'; }
          else if (isPhoneMorning) { cardText.innerText = 'Ab 9:00 Erreichbar'; cardDot.className = 'ap-status-dot pulse-red'; }
          else { cardText.innerText = 'Im Feierabend'; cardDot.className = 'ap-status-dot offline'; }
          p.className = 'ap-val ap-red';
        }
        p.innerText = sliderPhoneClosed;
      }

      if (isStoreOpen) {
        t.innerText = 'Ge\u00f6ffnet bis 16:00 Uhr';
        if (isPhoneClosingSoon) { t.className = 'ap-val ap-warning-text'; }
        else { t.className = 'ap-val ap-green'; }
      } else {
        t.innerText = sliderTimeClosed;
        t.className = 'ap-val ap-red';
      }
    }
    updateAppleTime();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["be-regional-widget"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var buttons = document.querySelectorAll('.be-segment-btn');
    var marker = document.getElementById('be-segment-marker');
    var sContent = document.getElementById('be-tab-standort');
    var vContent = document.getElementById('be-tab-versand');
    var mapToggle = document.getElementById('be-map-toggle');

    function switchTab(tabName, index) {
      buttons.forEach(function(btn) { btn.classList.remove('active'); });
      buttons[index].classList.add('active');
      marker.style.transform = 'translateX(' + (index * 100) + '%)';
      if (tabName === 'standort') {
        vContent.style.display = 'none'; sContent.style.display = 'block';
      } else {
        sContent.style.display = 'none'; vContent.style.display = 'block';
        var vContainer = document.getElementById('be-visual-container');
        if (vContainer.classList.contains('show-map')) { toggleMap(); }
      }
    }

    function toggleMap() {
      var vContainer = document.getElementById('be-visual-container');
      var btnText = document.getElementById('be-map-btn-text');
      vContainer.classList.toggle('show-map');
      mapToggle.classList.toggle('active');
      btnText.textContent = vContainer.classList.contains('show-map') ? "Karte schließen" : "Karte einblenden";
    }

    buttons.forEach(function(btn, index) {
      btn.addEventListener('click', function() { switchTab(btn.dataset.tab, index); });
    });
    mapToggle.addEventListener('click', toggleMap);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["be-security-widget"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var widget = document.getElementById('be-ts-widget');
    var body = document.getElementById('be-ts-body');

    widget.addEventListener('click', function() {
      widget.classList.toggle('expanded');
      body.style.maxHeight = widget.classList.contains('expanded') ? body.scrollHeight + 'px' : '0px';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-video-with-text"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.image-with-text__wrapper').forEach(section => {
    section.querySelectorAll('em').forEach(em => {
      const innerHTML = em.innerHTML;
      const newSpan = document.createElement('span');
      newSpan.classList.add('animated-marker-container');

      const textSpan = document.createElement('span');
      textSpan.classList.add('animated-marker');
      textSpan.style.setProperty('--marker-color', '#2c7af3');
      textSpan.innerHTML = `
        ${innerHTML}
        <svg class="svg-marker svg-marker--style1" width="201" height="14" viewBox="0 0 201 14" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <path d="M3 10.5732C55.565 6.61382 168.107 -0.117058 197.753 4.63415" stroke="var(--marker-color)" stroke-width="6" stroke-linecap="round"></path>
        </svg>
      `;

      newSpan.appendChild(textSpan);
      em.replaceWith(newSpan);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
